/* @flow */

import { responseHasError } from '../diplomatico/reducers/helper';
import type { Action } from '../diplomatico/types';
import mergeWithReplace from '../helpers/mergeWithReplace';
import { enableInitializing } from 'initializable-reducer';

const initialState = {};

function studentAchievementCardsProgress(state: Object = initialState, { type, payload }: Action) {
  switch (type) {
    case 'RESPONSE_STUDENT_ACHIEVEMENT_CARDS_PROGRESS':
      if (responseHasError(payload)) {
        return state;
      }

      const { intelligence_id, student_id } = payload._meta.payload.request;

      const newAchievementCardScore = {
        [student_id]: {
          [intelligence_id]:  payload.body
        }
      };

      return mergeWithReplace({}, [state, newAchievementCardScore]);
    default:
      return state;
  }
}

export {
  studentAchievementCardsProgress,
  initialState
};

export default enableInitializing(studentAchievementCardsProgress);
